export const DIAS_NUMBER_STRING: string[] = [
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10',
  '11',
  '12',
  '13',
  '14',
  '15',
  '16',
  '17',
  '18',
  '19',
  '20',
  '21',
  '22',
  '23',
  '24',
  '25',
  '26',
  '27',
  '28',
  '29',
  '30',
];

export const DIAS_STRING: string[] = [
  '1 DIA',
  '2 DIAS',
  '3 DIAS',
  '4 DIAS',
  '5 DIAS',
  '6 DIAS',
  '7 DIAS',
  '8 DIAS',
  '9 DIAS',
  '10 DIAS',
  '11 DIAS',
  '12 DIAS',
  '13 DIAS',
  '14 DIAS',
  '15 DIAS',
  '16 DIAS',
  '17 DIAS',
  '18 DIAS',
  '19 DIAS',
  '20 DIAS',
  '21 DIAS',
  '22 DIAS',
  '23 DIAS',
  '24 DIAS',
  '25 DIAS',
  '26 DIAS',
  '27 DIAS',
  '28 DIAS',
  '29 DIAS',
  '30 DIAS',
];

export const DIAS_ANTES_NUMBER_STRING: string[] = [
  '1 DIA ANTES',
  '2 DIAS ANTES',
  '3 DIAS ANTES',
  '4 DIAS ANTES',
  '5 DIAS ANTES',
  '6 DIAS ANTES',
  '7 DIAS ANTES',
  '8 DIAS ANTES',
  '9 DIAS ANTES',
  '10 DIAS ANTES',
  '11 DIAS ANTES',
  '12 DIAS ANTES',
  '13 DIAS ANTES',
  '14 DIAS ANTES',
  '15 DIAS ANTES',
  '16 DIAS ANTES',
  '17 DIAS ANTES',
  '18 DIAS ANTES',
  '19 DIAS ANTES',
  '20 DIAS ANTES',
  '21 DIAS ANTES',
  '22 DIAS ANTES',
  '23 DIAS ANTES',
  '24 DIAS ANTES',
  '25 DIAS ANTES',
  '26 DIAS ANTES',
  '27 DIAS ANTES',
  '28 DIAS ANTES',
  '29 DIAS ANTES',
  '30 DIAS ANTES',
];

export const DIAS_DESPUES_NUMBER_STRING: string[] = [
  '1 DIA DESPUES',
  '2 DIAS DESPUES',
  '3 DIAS DESPUES',
  '4 DIAS DESPUES',
  '5 DIAS DESPUES',
  '6 DIAS DESPUES',
  '7 DIAS DESPUES',
  '8 DIAS DESPUES',
  '9 DIAS DESPUES',
  '10 DIAS DESPUES',
  '11 DIAS DESPUES',
  '12 DIAS DESPUES',
  '13 DIAS DESPUES',
  '14 DIAS DESPUES',
  '15 DIAS DESPUES',
  '16 DIAS DESPUES',
  '17 DIAS DESPUES',
  '18 DIAS DESPUES',
  '19 DIAS DESPUES',
  '20 DIAS DESPUES',
  '21 DIAS DESPUES',
  '22 DIAS DESPUES',
  '23 DIAS DESPUES',
  '24 DIAS DESPUES',
  '25 DIAS DESPUES',
  '26 DIAS DESPUES',
  '27 DIAS DESPUES',
  '28 DIAS DESPUES',
  '29 DIAS DESPUES',
  '30 DIAS DESPUES',
];

export const DIAS_ANTES_DESPUES_NUMBER_STRING: string[] = [
  ...DIAS_ANTES_NUMBER_STRING,
  ...DIAS_DESPUES_NUMBER_STRING,
];

export const MES_VENCIDO_NUMBER_STRING: string[] = [
  '1 MES VENCIDO',
  '2 MESES VENCIDOS',
  '3 MESES VENCIDOS',
  '4 MESES VENCIDOS',
  '5 MESES VENCIDOS',
  '6 MESES VENCIDOS',
  '7 MESES VENCIDOS',
  '8 MESES VENCIDOS',
  '9 MESES VENCIDOS',
  '10 MESES VENCIDOS',
  '11 MESES VENCIDOS',
  '12 MESES VENCIDOS',
];

export const MES_GRATIS_STRING: string[] = [
  'ENERO',
  'FEBRERO',
  'MARZO',
  'ABRIL',
  'MAYO',
  'JUNIO',
  'JULIO',
  'AGOSTO',
  'SEPTIEMBRE',
  'OCTUBRE',
  'NOVIEMBRE',
  'DICIEMBRE',
];

export const CUOTAS_STRING: string[] = [
  '1RA CUOTA',
  '2DA CUOTA',
  '3RA CUOTA',
  '4TA CUOTA',
  '5TA CUOTA',
  '6TA CUOTA',
  '7MA CUOTA',
  '8VA CUOTA',
  '9NA CUOTA',
  '10MA CUOTA',
  '11VA CUOTA',
  '12VA CUOTA',
  '13RA CUOTA',
  '14TA CUOTA',
  '15TA CUOTA',
  '16TA CUOTA',
  '17MA CUOTA',
  '18VA CUOTA',
  '19NA CUOTA',
  '20MA CUOTA',
  '21VA CUOTA',
  '22DA CUOTA',
  '23RA CUOTA',
  '24TA CUOTA',
  '25TA CUOTA',
  '26TA CUOTA',
  '27MA CUOTA',
  '28VA CUOTA',
  '29NA CUOTA',
  '30MA CUOTA',
  '31VA CUOTA',
  '32DA CUOTA',
  '33RA CUOTA',
  '34TA CUOTA',
  '35TA CUOTA',
  '36TA CUOTA',
];
